import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { useImmerReducer } from 'use-immer';
import {
    Grid, Snackbar, Typography, Button, TextField, MenuItem,
    Alert, Container, Paper, Box, CircularProgress
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import StateContext from "../../../Contexts/StateContext";

import {
    areaOptions, AranyosszekOptions, CsikszekOptions, GyergyoszekOptions, KaszonfiuszekOptions, KereszturfiuszekOptions,
    KezdiszekOptions, MarosszekOptions, MiklosvarfiuszekOptions, OrbaiszekOptions, SepsiszekOptions, UdvarhelyszekOptions,
} from "../../../Constants/GeographicConstants";

function AddOwnCrop() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const GlobalState = useContext(StateContext);

    const config = require('../../../config').default;
    const environment = require('../../../config').environment;

    const initialState = {
        titleValue: '',
        categoryValue: '',
        descriptionValue: '',
        areaValue: '',
        boroughValue: '',
        priceValue: '',
        uploadedPictures: [],
        addressValue: '',
        geocodingError: '',
        geocodingSuccess: false,
        sendRequest: 0,
        openSnack: false,
        disabledBtn: false,
        error: '',
        // form errors
        titleErrors: { hasError: false, errorMessage: '' },
        categoryErrors: { hasError: false, errorMessage: '' },
        areaErrors: { hasError: false, errorMessage: '' },
        boroughErrors: { hasError: false, errorMessage: '' },
        priceErrors: { hasError: false, errorMessage: '' },
    };

    function ourReducer(draft, action) {
        switch (action.type) {
            case 'catchTitleChange':
                draft.titleValue = action.value;
                draft.titleErrors.hasError = false;
                draft.titleErrors.errorMessage = '';
                break;
            case 'catchCategoryChange':
                draft.categoryValue = action.value;
                draft.categoryErrors.hasError = false;
                draft.categoryErrors.errorMessage = '';
                break;
            case 'catchDescriptionChange':
                draft.descriptionValue = action.value;
                break;
            case 'catchAddressChange':
                draft.addressValue = action.value;
                draft.geocodingError = '';
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingError':
                draft.geocodingError = action.value;
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingSuccess':
                draft.geocodingSuccess = true;
                draft.geocodingError = '';
                break;
            case 'catchAreaChange':
                draft.areaValue = action.value;
                draft.areaErrors.hasError = false;
                draft.areaErrors.errorMessage = '';
                break;
            case 'catchBoroughChange':
                draft.boroughValue = action.value;
                draft.boroughErrors.hasError = false;
                draft.boroughErrors.errorMessage = '';
                break;
            case 'catchPriceChange':
                draft.priceValue = action.value;
                draft.priceErrors.hasError = false;
                draft.priceErrors.errorMessage = '';
                break;
            case 'catchUploadedPictures':
                draft.uploadedPictures = action.value;
                break;
            case 'changeSendRequest':
                draft.sendRequest++;
                break;
            case 'openTheSnack':
                draft.openSnack = true;
                break;
            case 'disableTheBtn':
                draft.disabledBtn = true;
                break;
            case 'enableTheBtn':
                draft.disabledBtn = false;
                break;
            case 'catchTitleErrors':
                draft.titleErrors.hasError = true;
                draft.titleErrors.errorMessage = action.value;
                break;
            case 'catchCategoryErrors':
                draft.categoryErrors.hasError = true;
                draft.categoryErrors.errorMessage = action.value;
                break;
            case 'catchAreaErrors':
                draft.areaErrors.hasError = true;
                draft.areaErrors.errorMessage = action.value;
                break;
            case 'catchBoroughErrors':
                draft.boroughErrors.hasError = true;
                draft.boroughErrors.errorMessage = action.value;
                break;
            case 'catchPriceErrors':
                draft.priceErrors.hasError = true;
                draft.priceErrors.errorMessage = action.value;
                break;
            case 'setError':
                draft.error = action.value;
                break;
            default:
                break;
        }
    }

    const [state, dispatch] = useImmerReducer(ourReducer, initialState);

    const produceCategories = [
        { value: 'Zoldseg', label: t('Market.Vegetables', 'Zöldség') },
        { value: 'Gyumolcs', label: t('Market.Fruits', 'Gyümölcs') },
        { value: 'Hus_Tejtermek', label: t('Market.DairyMeat', 'Hús és Tejtermék') },
        { value: 'Mez_Lekvar', label: t('Market.HoneyJam', 'Méz és Lekvár') },
        { value: 'Italok', label: t('Market.Drinks', 'Italok') },
        { value: 'Kezmuves', label: t('Market.Handicrafts', 'Kézműves termék') },
    ];

    const getBoroughOptions = () => {
        switch (state.areaValue) {
            case 'Aranyosszék': return AranyosszekOptions;
            case 'Csíkszék': return CsikszekOptions;
            case 'Gyergyószék': return GyergyoszekOptions;
            case 'Kászonszék': return KaszonfiuszekOptions;
            case 'Keresztúrszék': return KereszturfiuszekOptions;
            case 'Kézdiszék': return KezdiszekOptions;
            case 'Marosszék': return MarosszekOptions;
            case 'Miklósvárszék': return MiklosvarfiuszekOptions;
            case 'Orbaiszék': return OrbaiszekOptions;
            case 'Sepsiszék': return SepsiszekOptions;
            case 'Udvarhelyszék': return UdvarhelyszekOptions;
            default: return [];
        }
    };

    const handleGeocode = async () => {
        if (!state.addressValue) return;
        try {
            const response = await Axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(state.addressValue)}`);
            if (response.data && response.data.length > 0) {
                const { lat, lon } = response.data[0];
                dispatch({ type: 'catchLatitudeChange', value: parseFloat(lat) });
                dispatch({ type: 'catchLongitudeChange', value: parseFloat(lon) });
                dispatch({ type: 'setGeocodingSuccess' });
            } else {
                dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingNoResult', 'Nem található koordináta a megadott címhez.') });
            }
        } catch (e) {
            console.error("Geocoding error:", e);
            dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingError', 'Hiba történt a keresés során.') });
        }
    };

    function FormSubmit(e) {
        e.preventDefault();

        if (!state.titleValue) {
            dispatch({ type: 'catchTitleErrors', value: t('Validation.EmptyTitle') });
            window.scrollTo(0, 0);
            return;
        }
        if (!state.categoryValue) {
            dispatch({ type: 'catchCategoryErrors', value: t('Validation.EmptyCategory', 'Kérjük válasszon kategóriát!') });
            window.scrollTo(0, 0);
            return;
        }
        if (!state.areaValue) {
            dispatch({ type: 'catchAreaErrors', value: t('Validation.EmptyArea', 'Kérjük válasszon széket!') });
            window.scrollTo(0, 0);
            return;
        }
        if (!state.boroughValue) {
            dispatch({ type: 'catchBoroughErrors', value: t('Validation.EmptyBorough', 'Kérjük válasszon települést!') });
            window.scrollTo(0, 0);
            return;
        }
        if (!state.priceValue) {
            dispatch({ type: 'catchPriceErrors', value: t('Validation.EmptyPrice', 'Kérjük adjon meg árat!') });
            window.scrollTo(0, 0);
            return;
        }

        dispatch({ type: 'changeSendRequest' });
        dispatch({ type: 'disableTheBtn' });
    }

    useEffect(() => {
        if (state.sendRequest) {
            async function AddProduceFunc() {
                const formData = new FormData();
                formData.append('title', state.titleValue);
                formData.append('category', state.categoryValue);
                formData.append('description', state.descriptionValue);
                formData.append('address', state.addressValue);
                formData.append('area', state.areaValue);
                formData.append('borough', state.boroughValue);
                formData.append('price', state.priceValue);
                formData.append('seller', GlobalState.userId);

                // Add pictures
                for (let i = 0; i < state.uploadedPictures.length; i++) {
                    formData.append(`picture${i + 1}`, state.uploadedPictures[i]);
                }

                try {
                    await Axios.post(config[environment].ownProduceEndpoint, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    dispatch({ type: 'openTheSnack' });
                } catch (e) {
                    console.error(e.response);
                    dispatch({ type: 'enableTheBtn' });
                    dispatch({ type: 'setError', value: t('Common.Error') });
                }
            }
            AddProduceFunc();
        }
    }, [state.sendRequest]);

    useEffect(() => {
        if (state.openSnack) {
            setTimeout(() => {
                navigate(`/${i18n.language}/sajat-termeny`);
            }, 1500);
        }
    }, [state.openSnack, i18n.language]);

    const [isProducer, setIsProducer] = useState(false);
    const [loadingProducerCheck, setLoadingProducerCheck] = useState(true);

    useEffect(() => {
        async function checkProducerStatus() {
            if (GlobalState.userId) {
                try {
                    const response = await Axios.get(config[environment].businessesEndpoint, {
                        params: { owner: GlobalState.userId }
                    });
                    // Check if any business of the user is a producer/master/etc. 
                    // Or if they have a specific producer profile.
                    // For now, if they have any business record, we let them post produce.
                    if (response.data && response.data.length > 0) {
                        setIsProducer(true);
                    }
                } catch (e) {
                    console.error("Error checking producer status:", e);
                }
            }
            setLoadingProducerCheck(false);
        }
        checkProducerStatus();
    }, [GlobalState.userId]);

    if (!GlobalState.userIsLogged) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Alert severity="warning">
                    {t('Administration.LoginRequired', 'A folytatáshoz be kell jelentkeznie.')}
                </Alert>
                <Button variant="contained" onClick={() => navigate(`/${i18n.language}/login`)} sx={{ mt: 2 }}>
                    {t('Administration.LoginButton')}
                </Button>
            </Container>
        );
    }

    if (loadingProducerCheck) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!isProducer) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Alert severity="info" sx={{ mb: 2 }}>
                    {t('Market.ProducerRegistrationRequired')}
                </Alert>
                <Button variant="contained" onClick={() => navigate(`/${i18n.language}/uzleti-regisztracio`)} sx={{ bgcolor: 'green' }}>
                    {t('Accommodation.RegisterAsProducer')}
                </Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: 4, mt: '50px' }}>
            <Paper sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom sx={{ color: 'green', fontWeight: 'bold' }}>
                    {t('Accommodation.RegisterAsProducer')}
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                    {t('Accommodation.RegisterProducerIntro')}
                </Typography>

                <form onSubmit={FormSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('Common.Title')}
                                value={state.titleValue}
                                onChange={(e) => dispatch({ type: 'catchTitleChange', value: e.target.value })}
                                error={state.titleErrors.hasError}
                                helperText={state.titleErrors.errorMessage}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label={t('Common.Category')}
                                value={state.categoryValue}
                                onChange={(e) => dispatch({ type: 'catchCategoryChange', value: e.target.value })}
                                error={state.categoryErrors.hasError}
                                helperText={state.categoryErrors.errorMessage}
                                required
                            >
                                {produceCategories.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                type="number"
                                label={t('Common.Price')}
                                value={state.priceValue}
                                onChange={(e) => dispatch({ type: 'catchPriceChange', value: e.target.value })}
                                error={state.priceErrors.hasError}
                                helperText={state.priceErrors.errorMessage}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label={t('Map.Toolbox.szek')}
                                value={state.areaValue}
                                onChange={(e) => dispatch({ type: 'catchAreaChange', value: e.target.value })}
                                error={state.areaErrors.hasError}
                                helperText={state.areaErrors.errorMessage}
                                required
                            >
                                {areaOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                fullWidth
                                label={t('Map.Toolbox.telepules')}
                                value={state.boroughValue}
                                onChange={(e) => dispatch({ type: 'catchBoroughChange', value: e.target.value })}
                                error={state.boroughErrors.hasError}
                                helperText={state.boroughErrors.errorMessage}
                                required
                                disabled={!state.areaValue}
                            >
                                {getBoroughOptions().map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label={t('Common.Description')}
                                value={state.descriptionValue}
                                onChange={(e) => dispatch({ type: 'catchDescriptionChange', value: e.target.value })}
                                placeholder={t('Market.ProduceDescriptionPlaceholder')}
                            />
                        </Grid>

                        <Grid item container sx={{ mt: 2 }} spacing={2}>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label={t('Common.Address')}
                                    value={state.addressValue}
                                    onChange={(e) => dispatch({ type: 'catchAddressChange', value: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    onClick={handleGeocode}
                                    sx={{ height: '56px' }}
                                >
                                    {t('Thematic.Geocode')}
                                </Button>
                            </Grid>
                            {state.geocodingError && (
                                <Grid item xs={12}>
                                    <Alert severity="error" sx={{ mt: 1 }}>
                                        {state.geocodingError}
                                    </Alert>
                                </Grid>
                            )}
                            {state.geocodingSuccess && (
                                <Grid item xs={12}>
                                    <Alert severity="success" sx={{ mt: 1 }}>
                                        {t('Thematic.GeocodingSuccess')}
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                component="label"
                                sx={{ bgcolor: 'green' }}
                            >
                                {t('Common.UploadPictures', 'Képek feltöltése')}
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    accept="image/*"
                                    onChange={(e) => dispatch({ type: 'catchUploadedPictures', value: e.target.files })}
                                />
                            </Button>
                            {state.uploadedPictures.length > 0 && (
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                    {state.uploadedPictures.length} {t('Common.FilesSelected', 'fájl kiválasztva')}
                                </Typography>
                            )}
                        </Grid>

                        <Grid item xs={12}>
                            {state.error && <Alert severity="error" sx={{ mb: 2 }}>{state.error}</Alert>}
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    disabled={state.disabledBtn}
                                    sx={{ bgcolor: 'green', px: 4 }}
                                >
                                    {state.disabledBtn ? <CircularProgress size={24} /> : t('Common.Submit', 'Beküldés')}
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="large"
                                    onClick={() => navigate(-1)}
                                >
                                    {t('Common.Cancel', 'Mégse')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <Snackbar
                open={state.openSnack}
                autoHideDuration={3000}
                onClose={() => dispatch({ type: 'openTheSnack', value: false })}
            >
                <Alert severity="success" sx={{ width: '100%' }}>
                    {t('Common.Success', 'Sikeresen feladta a hirdetést!')}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default AddOwnCrop;